// removed by extract-text-webpack-plugin
module.exports = {"container":"bn_g","layout":"bn_am","header":"bn_bg _1AvxiCsDEMdGie2oWv5Qv_","title":"bn_n","subtitle":"bn_bo","button":"bn_bp","breadcrumb":"bn_bq _2HU8ZgmfpIdsUwklJ4Ng6B _3JIEYde9anI6O5H5wYv2ik","categoryList":"bn_br _2HU8ZgmfpIdsUwklJ4Ng6B _3JIEYde9anI6O5H5wYv2ik","heading":"bn_i","listContainer":"bn_bs","content":"bn_bt","more":"bn_bu","exploreList":"bn_bv _2HU8ZgmfpIdsUwklJ4Ng6B _3JIEYde9anI6O5H5wYv2ik","exploreLink":"bn_bw","benefits":"bn_bx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Discovery/styles.module.css
// module id = 1255
// module chunks = 27